import { CardProps as MuiCardProps } from '@mui/material/Card'

export interface CardProps extends MuiCardProps {
  hoverElevation?: MuiCardProps['elevation']
}
